import { omitBy, isArray, isPlainObject, mapKeys, mapValues, map, cloneDeep } from 'lodash'

export const compact = obj => {
  return omitBy(obj, v => !v)
}

export const truthyOrZero = v => v || v === 0
